import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";
import { ExternalProps } from "constants/external";

const ErrorMessage = () => (
  <ComponentDocs
    name="<ErrorMessage/>"
    entry="ErrorMessage"
    propsEntry="ErrorMessageProps"
    externalProps={ExternalProps.MuiAlert}
  >
    <ComponentExample
      name="String Error / Custom Header"
      import={import("examples/Api/ErrorMessage/StringErrorExample")}
      rawImport={import("examples/Api/ErrorMessage/StringErrorExample?raw")}
    />
    <ComponentExample
      name="API Error"
      import={import("examples/Api/ErrorMessage/ApiErrorExample")}
      rawImport={import("examples/Api/ErrorMessage/ApiErrorExample?raw")}
    />
    <ComponentExample
      name="Override Messages"
      description="Error messages from an API can be overridden if necessary."
      import={import("examples/Api/ErrorMessage/OverrideMessagesExample")}
      rawImport={import(
        "examples/Api/ErrorMessage/OverrideMessagesExample?raw"
      )}
    />
  </ComponentDocs>
);

export default ErrorMessage;
